export default "__VITE_ASSET__DnorokDD__"